const Collapse = () => {
  $('[data-collapse-target]').on('click', function() {
    const collapse = $(this).closest('[data-collapse]');

    collapse.find('[data-collapse-content]').slideToggle(300);
  })
}

export default Collapse;



// WEBPACK FOOTER //
// ./scripts/components/Collapse.js